import { useState } from 'react';

export const ORDER_DETAIL_SCAN_MODES = {
  QR: 'qr',
  BARCODE: 'barcode',
} as const;

export type OrderDetailScanMode =
  (typeof ORDER_DETAIL_SCAN_MODES)[keyof typeof ORDER_DETAIL_SCAN_MODES];

const SCAN_MODE_STORAGE_KEY = 'orderDetailScanMode';

export function readOrderDetailScanMode(): OrderDetailScanMode {
  return sessionStorage.getItem(SCAN_MODE_STORAGE_KEY) === ORDER_DETAIL_SCAN_MODES.QR
    ? ORDER_DETAIL_SCAN_MODES.QR
    : ORDER_DETAIL_SCAN_MODES.BARCODE;
}

export function writeOrderDetailScanMode(mode: OrderDetailScanMode): void {
  sessionStorage.setItem(SCAN_MODE_STORAGE_KEY, mode);
}

export interface OrderDetailScanModeState {
  readonly qrActive: boolean;
  readonly toggleScanMode: () => void;
}

export function useOrderDetailScanMode(): OrderDetailScanModeState {
  const [mode, setMode] = useState<OrderDetailScanMode>(readOrderDetailScanMode);

  const toggleScanMode = (): void => {
    setMode((prev) => {
      const next: OrderDetailScanMode =
        prev === ORDER_DETAIL_SCAN_MODES.QR
          ? ORDER_DETAIL_SCAN_MODES.BARCODE
          : ORDER_DETAIL_SCAN_MODES.QR;
      writeOrderDetailScanMode(next);
      return next;
    });
  };

  return { qrActive: mode === ORDER_DETAIL_SCAN_MODES.QR, toggleScanMode };
}
